import { mdiPencilOutline } from "@mdi/js"
import { buildTableRowActionSet } from "@kontextwerk/web-sdk/core/layout/table"
import type { InboxWorkflowRowActionProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import type { LetterSelectionDraft, LetterSelectionRow } from "../../../contract"

export const recipientEditorReason = (row: LetterSelectionRow, draft: LetterSelectionDraft) => {
  if (row.disabled || row.isResolved)
    return row.disabledReason || "Diese Zeile kann nicht mehr bearbeitet werden."

  if (draft.ignored) return "Ignorierte Terminbriefe werden nicht bearbeitet."

  if (draft.mode !== "PERSONAL_LETTER")
    return "Für diese Strategie wird die Liegenschaftsadresse verwendet. Wählen Sie einen persönlichen Empfänger oder Individuell erfassen."

  return null
}

export const recipientEditorActions = (
  props: InboxWorkflowRowActionProps<LetterSelectionRow, LetterSelectionDraft>,
) => {
  const reason = recipientEditorReason(props.row, props.draft)

  return buildTableRowActionSet(
    [
      {
        id: "edit-recipient-address",
        label: "Zieladresse bearbeiten",
        tooltip: "Zieladresse bearbeiten",
        icon: mdiPencilOutline,
        disabled: props.disabled || props.readOnly || Boolean(reason) || !props.openEditor,
        disabledReason:
          reason ||
          (props.disabled || props.readOnly
            ? "Diese Zeile ist abgeschlossen oder wird gerade verarbeitet."
            : null),
        onClick: () => props.openEditor?.(),
      },
    ],
    { primaryId: "edit-recipient-address" },
  )
}

export const recipientEditorContext = (row: LetterSelectionRow, draft: LetterSelectionDraft) =>
  JSON.stringify([
    row.id,
    draft.mode,
    draft.recipientValue,
    draft.recipientCustomerId,
    draft.recipientContactPointId,
    draft.recipientSource,
  ])

export const destinationAddressLines = (row: LetterSelectionRow, draft: LetterSelectionDraft) => {
  const personal = draft.mode === "PERSONAL_LETTER"
  const address = personal
    ? draft.recipientAddress
    : (draft.propertyAddress ?? row.property_address)
  const text = (value: string | null | undefined) => value?.trim() || ""
  const structuredLines = [
    [address?.street, address?.house_number].map(text).filter(Boolean).join(" "),
    address?.address_extra,
    [address?.zip, address?.city].map(text).filter(Boolean).join(" "),
    address?.country,
  ]
    .map(text)
    .filter(Boolean)
  const lines = structuredLines.length
    ? structuredLines
    : address?.lines?.length
      ? address.lines
      : [address?.label]

  return [personal ? draft.recipientName : null, ...lines].map(text).filter(Boolean)
}
